import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NavController } from '@ionic/angular';
import {
  createPostObject,
  Post,
} from '@jaimo-solutions-gmbh/platform-services-module';
import { getSuggestedEntries } from '../api/explore';

@Component({
  selector: 'app-suggested-posts',
  templateUrl: './suggested-posts.component.html',
  styleUrls: ['./suggested-posts.component.scss'],
})
export class SuggestedPostsComponent implements OnInit {
  posts: Post[] = [];
  isLoading;

  constructor(private navCtrl: NavController, public sanitizer: DomSanitizer) {
    this.isLoading = true;
    getSuggestedEntries()
      .then((res) => {
        this.posts = res.map(createPostObject);
        this.posts.forEach((post) => {
          post.content =
            post.content.substring(0, 149) +
            (post.content.length > 150 ? '...' : '');
        });
        this.isLoading = false;
      })
      .catch(console.error);
  }

  ngOnInit() {}

  goToPost(post) {
    window.location.href =
      '/' + post.source.accountSource.handle + '/' + post.uniqueShortId;
  }

  goToStage(post) {
    this.navCtrl.navigateForward('/' + post.source.accountSource.handle, {
      animated: false,
    });
  }
}
